import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button, Container } from "../..";
import Modal from "../Modal/Modal"; // eslint-disable-line import/no-named-as-default
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ModalConfirm = function ModalConfirm(_ref) {
  var onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    onDraft = _ref.onDraft,
    open = _ref.open;
  return /*#__PURE__*/_jsxs(Modal, {
    open: open,
    size: "small",
    colorHeader: "#FF9900",
    children: [/*#__PURE__*/_jsxs(Modal.Header, {
      children: [/*#__PURE__*/_jsx(Icon, {
        name: "warning sign"
      }), "Informations non enregistr\xE9es"]
    }), /*#__PURE__*/_jsx(Modal.Content, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx("p", {
          children: "Certaines \xE9tapes comportent des modifications non valid\xE9es."
        }), /*#__PURE__*/_jsx("p", {
          children: "Voulez-vous enregistrer en tant que brouillon ?"
        })]
      })
    }), /*#__PURE__*/_jsxs(Modal.Actions, {
      children: [/*#__PURE__*/_jsx(Button, {
        size: "tiny",
        basic: true,
        icon: "times",
        content: "Annuler",
        onClick: onCancel
      }), /*#__PURE__*/_jsx(Button, {
        negative: true,
        icon: "trash alternate",
        content: "Non",
        onClick: onClose
      }), /*#__PURE__*/_jsx(Button, {
        color: "green",
        icon: "check",
        content: "Oui",
        onClick: onDraft
      })]
    })]
  });
};
ModalConfirm.handledProps = ["onCancel", "onClose", "onDraft", "open"];
ModalConfirm.propTypes = {
  /** Callback du bouton Annuler */
  onCancel: PropTypes.func,
  /** Callback du bouton Non */
  onClose: PropTypes.func,
  /** Callback du bouton Oui */
  onDraft: PropTypes.func,
  /** Défini si la modal de confirmation est ouverte */
  open: PropTypes.bool
};
export default ModalConfirm;